import { Location } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { BOTONES } from '../botones';
import { TooltipDirective } from '../../auxiliares/tooltip/tooltip.directive';
import { OrigenService } from '../../auxiliares/servicios/origen.service';
import { abreAparte } from './breadcrumb.component';

/**
 * Barra de migas del shell, para las páginas **sin cabecera de detalle** a las
 * que se llega por un cruce: un dashboard → un listado filtrado, un detalle →
 * sus eventos o sus logs. Los detalles ya las muestran en su cabecera
 * (`app-breadcrumb`) y ahí la barra se esconde; entrando por el menú no hay
 * de dónde volver y tampoco aparece.
 */
@Component({
  selector: 'app-barra-migas',
  standalone: true,
  imports: [MatIconModule, BOTONES, TooltipDirective],
  template: `
    @if (visible()) {
      <nav class="breadcrumb-section barra-migas" aria-label="De dónde viniste">
        <a
          irxBotonIcono
          class="back-button"
          [attr.href]="href(origen.anterior()!.url)"
          [tooltip]="'Volver a ' + origen.anterior()!.titulo"
          [attr.aria-label]="'Volver a ' + origen.anterior()!.titulo"
          (click)="volver($event)"
        >
          <mat-icon>arrow_back</mat-icon>
        </a>
        <ol class="breadcrumb-content">
          @for (m of origen.migas(); track m.pagina; let i = $index) {
            <li>
              <a
                class="irx-enlace breadcrumb-text"
                [attr.href]="href(m.url)"
                (click)="ir($event, i)"
              >
                {{ m.titulo }}
              </a>
              @if (!$last) {
                <mat-icon class="breadcrumb-separator" aria-hidden="true">
                  chevron_right
                </mat-icon>
              }
            </li>
          }
        </ol>
      </nav>
    }
  `,
  styleUrls: ['./breadcrumb.component.scss'],
  styles: `
    .barra-migas {
      padding: 0.25rem 1rem 0;
    }
  `,
})
export class BarraMigasComponent {
  protected readonly origen = inject(OrigenService);
  private readonly location = inject(Location);

  protected readonly visible = computed(
    () => this.origen.migas().length > 0 && !this.origen.enCabecera(),
  );

  protected href(url: string): string {
    return this.location.prepareExternalUrl(url);
  }

  protected volver(e: MouseEvent): void {
    if (abreAparte(e)) return;
    e.preventDefault();
    this.origen.volver('/main');
  }

  protected ir(e: MouseEvent, indice: number): void {
    if (abreAparte(e)) return;
    e.preventDefault();
    this.origen.volver('/main', indice);
  }
}
